(() => {
  if (!('ResizeObserver' in window)) return;
  const start = () => {
    const images = document.querySelectorAll('#main-collection-product-grid .ae-native-card-image[loading="eager"]');
    if (!images.length) return;
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const width = Math.ceil(entry.contentRect.width);
        if (width > 0 && entry.target.sizes !== `${width}px`) {
          entry.target.sizes = `${width}px`;
        }
      }
    });
    images.forEach(image => observer.observe(image));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
